<template>
  <div v-if="!hasPermission('List Bank Account')">Você não tem permissão para acessar esta página!</div>
  <div v-else>
    <Toolbar />
    <div class="container-xxl">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                      transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                <path
                    d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                    fill="black"></path>
              </svg>
            </span>
            <input type="text" data-kt-user-table-filter="search" v-model="search"
                   class="form-control form-control-solid w-250px ps-14"
                   placeholder="Pesquisar ...">
          </div>
        </div>
        <div class="card-toolbar">
          <button v-if="hasPermission('Store Bank Account')" class="btn btn-flex btn-primary m-1" data-bs-toggle="modal"
                  title="Nova conta bancária" data-bs-target="#modal_store_bank_account"
                  @click="resetFormStore">
            <i class="bi bi-plus-lg"></i> Adicionar
          </button>
        </div>
      </div>
      <div class="card-body py-4">
        <table class="table table-row-bordered gy-5">
          <thead>
          <tr class="fw-bold fs-6 text-muted">
            <th>Nome</th>
            <th>Tipo</th>
            <th>Banco</th>
            <th>Agência/Conta</th>
            <th>Ativo</th>
            <th>Ações</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="account in accountsFiltered" :key="account.id">
            <td>{{ account.name }}</td>
            <td>
              <span class="badge badge-info">{{ account.account_type === 'cash' ? 'Caixa' : account.account_type === 'checking' ? 'Conta Corrente' : 'Poupança' }}</span>
            </td>
            <td>{{ account.bank_name || '-' }}</td>
            <td>
              <span v-if="account.account_type !== 'cash'">
                {{ account.agency ? `${account.agency} / ${account.account_number || '-'}` : '-' }}
              </span>
              <span v-else class="text-muted">-</span>
            </td>
            <td>
              <span :class="account.active ? 'badge badge-success' : 'badge badge-danger'">
                {{ account.active ? 'Sim' : 'Não' }}
              </span>
            </td>
            <td>
              <button v-if="hasPermission('Update Bank Account')" type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                      :disabled="account.is_system"
                      :data-bs-toggle="account.is_system ? null : 'modal'"
                      :data-bs-target="account.is_system ? null : '#modal_edit_bank_account'"
                      @click="onClickBtnEdit(account)"
                      :title="account.is_system ? 'Registros do sistema não podem ser editados' : 'Editar'">
                <i class="bi bi-pencil-square"></i>
              </button>
              <button v-if="hasPermission('Delete Bank Account')" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                      :disabled="account.is_system"
                      @click="deleteAccount(account.id)"
                      data-bs-toggle="tooltip"
                      :title="account.is_system ? 'Registros do sistema não podem ser excluídos' : 'Excluir'">
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-if="accountsFiltered.length === 0">
            <td colspan="6" class="text-center text-muted py-10">
              Nenhuma conta bancária cadastrada
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Store -->
    <div class="modal fade" tabindex="-1" id="modal_store_bank_account">
      <div class="modal-dialog modal-lg">
        <form method="post" @submit.prevent="submitFormStore">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Nova Conta Bancária</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                   aria-label="Fechar">
                <i class="bi bi-x-lg"></i>
              </div>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="name_store" class="required form-label">Nome</label>
                    <input type="text" class="form-control form-control-solid" id="name_store"
                           placeholder="Ex: Conta Principal, Caixa, Conta Poupança"
                           v-model="formStore.name" required>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="account_type_store" class="required form-label">Tipo de Conta</label>
                    <select class="form-select form-select-solid" id="account_type_store"
                            v-model="formStore.account_type" required @change="onAccountTypeChange">
                      <option value="">Selecione o tipo</option>
                      <option value="cash">Caixa (Dinheiro em Espécie)</option>
                      <option value="checking">Conta Corrente</option>
                      <option value="savings">Poupança</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-12" v-if="formStore.account_type !== 'cash'">
                  <div class="mb-6">
                    <label for="bank_name_store" class="form-label">Nome do Banco</label>
                    <input type="text" class="form-control form-control-solid" id="bank_name_store"
                           placeholder="Ex: Banco do Brasil, Itaú, Bradesco"
                           v-model="formStore.bank_name">
                  </div>
                </div>
                <div class="row" v-if="formStore.account_type !== 'cash'">
                  <div class="col-md-6">
                    <div class="mb-6">
                      <label for="agency_store" class="form-label">Agência</label>
                      <input type="text" class="form-control form-control-solid" id="agency_store"
                             placeholder="0000"
                             v-model="formStore.agency">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-6">
                      <label for="account_number_store" class="form-label">Número da Conta</label>
                      <input type="text" class="form-control form-control-solid" id="account_number_store"
                             placeholder="00000-0"
                             v-model="formStore.account_number">
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-check form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox"
                           v-model="formStore.active" id="active_store" checked/>
                    <label class="form-check-label" for="active_store">
                      Ativo
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
              <button type="submit" class="btn btn-primary">Cadastrar</button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Modal Edit -->
    <div class="modal fade" tabindex="-1" id="modal_edit_bank_account">
      <div class="modal-dialog modal-lg">
        <form method="post" @submit.prevent="submitFormEdit">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Editar Conta Bancária</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                   aria-label="Fechar">
                <i class="bi bi-x-lg"></i>
              </div>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="name_edit" class="required form-label">Nome</label>
                    <input type="text" class="form-control form-control-solid" id="name_edit"
                           placeholder="Ex: Conta Principal, Caixa, Conta Poupança"
                           v-model="formEdit.name" required>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="account_type_edit" class="required form-label">Tipo de Conta</label>
                    <select class="form-select form-select-solid" id="account_type_edit"
                            v-model="formEdit.account_type" required @change="onAccountTypeChangeEdit">
                      <option value="">Selecione o tipo</option>
                      <option value="cash">Caixa (Dinheiro em Espécie)</option>
                      <option value="checking">Conta Corrente</option>
                      <option value="savings">Poupança</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-12" v-if="formEdit.account_type !== 'cash'">
                  <div class="mb-6">
                    <label for="bank_name_edit" class="form-label">Nome do Banco</label>
                    <input type="text" class="form-control form-control-solid" id="bank_name_edit"
                           placeholder="Ex: Banco do Brasil, Itaú, Bradesco"
                           v-model="formEdit.bank_name">
                  </div>
                </div>
                <div class="row" v-if="formEdit.account_type !== 'cash'">
                  <div class="col-md-6">
                    <div class="mb-6">
                      <label for="agency_edit" class="form-label">Agência</label>
                      <input type="text" class="form-control form-control-solid" id="agency_edit"
                             placeholder="0000"
                             v-model="formEdit.agency">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-6">
                      <label for="account_number_edit" class="form-label">Número da Conta</label>
                      <input type="text" class="form-control form-control-solid" id="account_number_edit"
                             placeholder="00000-0"
                             v-model="formEdit.account_number">
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-check form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox"
                           v-model="formEdit.active" id="active_edit"/>
                    <label class="form-check-label" for="active_edit">
                      Ativo
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
              <button type="submit" class="btn btn-primary">Salvar</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import http from "@/helpers/http";
import Alert from "@/helpers/alert";
import Permission from "@/helpers/permission";
import Toolbar from "@/components/layouts/auth/Toolbar.vue";

export default {
  name: "BankAccount",
  components: {
    Toolbar,
  },
  data() {
    return {
      search: '',
      accounts: [],
      formStore: {
        name: '',
        account_type: '',
        bank_name: '',
        agency: '',
        account_number: '',
        active: true,
      },
      formEdit: {
        id: null,
        name: '',
        account_type: '',
        bank_name: '',
        agency: '',
        account_number: '',
        active: true,
      },
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    accountsFiltered() {
      return this.accounts.filter(account => {
        return account.name.toLowerCase().includes(this.search.toLowerCase()) ||
               (account.bank_name && account.bank_name.toLowerCase().includes(this.search.toLowerCase()))
      });
    },
  },
  mounted() {
    this.loadAccounts();
  },
  methods: {
    hasPermission(permission) {
      return Permission.has(permission);
    },
    loadAccounts() {
      http.get(`/places/${this.place.id_place}/finances/bank-accounts`).then((response) => {
        this.accounts = response.data;
      }).catch(() => {
        this.accounts = [];
      });
    },
    resetFormStore() {
      this.formStore = {
        name: '',
        account_type: '',
        bank_name: '',
        agency: '',
        account_number: '',
        active: true,
      };
    },
    onAccountTypeChange() {
      if (this.formStore.account_type === 'cash') {
        this.formStore.bank_name = '';
        this.formStore.agency = '';
        this.formStore.account_number = '';
      }
    },
    onAccountTypeChangeEdit() {
      if (this.formEdit.account_type === 'cash') {
        this.formEdit.bank_name = '';
        this.formEdit.agency = '';
        this.formEdit.account_number = '';
      }
    },
    submitFormStore() {
      http.post(`/places/${this.place.id_place}/finances/bank-accounts`, this.formStore).then(() => {
        this.loadAccounts();
        Alert.toastSuccess("Conta bancária cadastrada com sucesso.");
        this.resetFormStore();
        bootstrap.Modal.getInstance(document.getElementById('modal_store_bank_account')).hide();
      }).catch(e => {
        Alert.toastError(e.response?.data?.message || "Erro ao cadastrar conta bancária.");
      });
    },
    submitFormEdit() {
      http.put(`/places/${this.place.id_place}/finances/bank-accounts/${this.formEdit.id}`, this.formEdit).then(() => {
        this.loadAccounts();
        Alert.toastSuccess("Conta bancária atualizada com sucesso.");
        bootstrap.Modal.getInstance(document.getElementById('modal_edit_bank_account')).hide();
      }).catch(e => {
        Alert.toastError(e.response?.data?.message || "Erro ao atualizar conta bancária.");
      });
    },
    onClickBtnEdit(account) {
      if (account.is_system) {
        Alert.toastError("Registros do sistema não podem ser editados.");
        return;
      }
      this.formEdit = {
        id: account.id,
        name: account.name,
        account_type: account.account_type,
        bank_name: account.bank_name || '',
        agency: account.agency || '',
        account_number: account.account_number || '',
        active: account.active !== false,
      };
    },
    deleteAccount(id) {
      const account = this.accounts.find(a => a.id === id);
      if (account?.is_system) {
        Alert.toastError("Registros do sistema não podem ser excluídos.");
        return;
      }
      Swal.fire({
        title: 'Tem certeza?',
        text: "Esta ação não pode ser desfeita!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secondary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/places/${this.place.id_place}/finances/bank-accounts/${id}`).then(() => {
            this.loadAccounts();
            Alert.toastSuccess("Conta bancária excluída com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response?.data?.message || "Erro ao excluir conta bancária.");
          });
        }
      });
    },
  }
}
</script>

<style scoped>
</style>

